var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dot rounded-pill",class:_vm.color})
}
var staticRenderFns = []

export { render, staticRenderFns }